import { render, staticRenderFns } from "./primeiropedido.vue?vue&type=template&id=838c693e"
import script from "./primeiropedido.vue?vue&type=script&lang=js"
export * from "./primeiropedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports